import { LineItem, OnUpdateCallback } from '@app/components/LineItem';
import { Item } from '@app/types/monolith/cart';
import { AnalyticsPageTypeProperty } from '@redbubble/next-analytics/gtm';

export interface CartLineItemContainerProps {
  item: Item;
  showTaxSeparately?: boolean;
  currency: string;
  analyticsPageType: AnalyticsPageTypeProperty;
  onUpdate?: OnUpdateCallback;
  errorString?: string;
  editable?: boolean;
  onLoadingChange?: () => void;
  disableAddButton?: boolean;
  narrow?: boolean;
}

export const CartLineItemContainer = ({
  item,
  showTaxSeparately = false,
  currency,
  analyticsPageType,
  onUpdate,
  errorString,
  editable,
  disableAddButton = false,
  narrow = false,
}: CartLineItemContainerProps) => {
  const undiscountedTotalAmount = showTaxSeparately
    ? item.undiscounted_total_price_ex_tax
    : item.undiscounted_total_price;

  const totalPrice = showTaxSeparately
    ? item.total_price_ex_tax
    : item.total_price;

  const unitPrice = showTaxSeparately
    ? item.item_price_ex_tax
    : item.item_price;

  return (
    <LineItem
      item={item}
      showTaxSeparately={showTaxSeparately}
      productUrl={item.work_url}
      imageUrl={item.image_url}
      productType={item.details.type}
      productTypeId={item.product_type_id || ''}
      productOptions={item.details.options}
      marketingSku={item.marketing_sku || ''}
      workTitle={item.work_title || ''}
      artistName={item.artist_name || ''}
      total={totalPrice}
      totalShipping={item.total_shipping_price}
      undiscountedTotal={undiscountedTotalAmount}
      currency={currency}
      quantity={item.quantity}
      itemId={String(item.id)}
      analyticsPageType={analyticsPageType}
      workId={String(item.work_id)}
      blankItemId={item.blank_item_id || ''}
      marketingProductTypeId={item.marketing_product_type_id || ''}
      unitPrice={unitPrice}
      isDigital={item.is_digital}
      showQuantity={!item.fixed_quantity}
      gaCode={item.ga_code}
      onLoadingChange={() => {}}
      onUpdate={onUpdate}
      updateError={errorString}
      editable={editable}
      narrow={narrow}
      disableAddButton={disableAddButton}
    />
  );
};
